/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-29 07:48:04
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Link } from '@shopify/polaris';
import { ImportMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';

import * as redirectActions from 'src/stores/actions/redirect-actions';

type Props = {
  active: boolean,
  exporting: boolean,
  handleChange: () => void,
  handleExport: () => void,
  exportFile: () => void
};

type ComposedProps = Props & WithI18nProps;

class ExportModal extends Component<ComposedProps> {
  render() {
    const { i18n, active, exporting } = this.props;

    return (
      <Modal
        large
        open={active}
        onClose={this.handleChange}
        title={i18n.translate('AdminHTML.Redirects.Export.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.export'),
          loading: exporting,
          onAction: this.handleExport
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleChange
          }
        ]}>
        <Modal.Section>
          <p>
            {i18n.translate('AdminHTML.Redirects.Export.message', {
              t1: (
                <Link external url={URL['EditRedirect']}>
                  {i18n.translate('AdminHTML.Redirects.Export.message_t1')}
                </Link>
              )
            })}
          </p>
          <div style={{ textAlign: 'center', padding: '1.25rem 0' }}>
            <Button size="slim" icon={ImportMinor}></Button>
            <p style={{ paddingTop: '5px', fontWeight: 600 }}>All redirects data.csv</p>
          </div>
          <p>
            {i18n.translate('AdminHTML.Redirects.Export.learnMore', {
              t1: (
                <Link external url={URL['ExportRedirects']}>
                  {i18n.translate('AdminHTML.Redirects.Export.learnMore_t1')}
                </Link>
              )
            })}
          </p>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };

  handleExport = () => {
    this.props.exportFile();
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  exportFile: () => dispatch(redirectActions.exportFile(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  return {
    exporting: _.get(state.redirect, 'exporting', false)
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ExportModal));
